import { QueryClientProvider, QueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { AppInsightsProvider } from 'Features/error/AppInsightsProvider'
import { AppThemeProvider } from 'Features/app/AppThemeProvider'
import { Toaster } from 'Common/Supplyvue-ui'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from 'Features/auth/msal-instance'
import { RunFailureDetailsHost } from 'Features/Scheduler/RunFailureDetails'

type AppProvidersProps = {
  children: React.ReactNode
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  })

  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <AppThemeProvider>
          <Toaster />
          <RunFailureDetailsHost />
          <AppInsightsProvider>{children}</AppInsightsProvider>
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </AppThemeProvider>
      </QueryClientProvider>
    </MsalProvider>
  )
}
